import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/reset.css'
import router from './router'
import store from './store'
import 'swiper/css';

const app = createApp(App)
app.use(store).use(router).mount('#app')
